import styles from './Spinner.module.css';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function Spinner({ size = 'md' }: SpinnerProps) {
  return <span className={[styles.spinner, styles[size]].join(' ')} role="status" aria-label="Caricamento" />;
}

/** Centered spinner with optional caption, for full-section loading states. */
export function LoadingState({ label = 'Caricamento…' }: { label?: string }) {
  return (
    <div className={styles.center}>
      <Spinner />
      <span>{label}</span>
    </div>
  );
}
